export default __webpack_public_path__ + "static/media/labWithPeople.544cd002.svg";